import React from 'react';

import CardContent from '@mui/material/CardContent';
import {
  projectDataStyle,
  ChipWrapper,
  ProjectStatusContent,
  ProjectStatusWrapper,
} from 'component/ProjectStatus/ProjectStatus.s';
import { ProjectStatusLabel } from 'component/ProjectStatusLabel/ProjectStatusLabel';
import { ProjectModel } from 'api/dto/Project.dto';
import { Dayjs } from 'dayjs';

export namespace ProjectStatus {
  export type Props = {
    project: ProjectModel;
    liveStart: Dayjs;
    liveStop: Dayjs;
    className?: string;
  };
}

export const ProjectStatus: React.FC<ProjectStatus.Props> = (props) => (
  <ProjectStatusWrapper className={props.className}>
    <ProjectStatusContent>
      <h6>Status</h6>
      <ChipWrapper
        data-testid="projectStatus"
        label={<ProjectStatusLabel status={props.project.status} kind={props.project.kind} />}
      />
      {props.liveStart && props.liveStop && (
        <CardContent style={projectDataStyle} data-testid="projectLiveStartAndStop">
          {`(${props.liveStart.format('D MMM YY')} - ${props.liveStop.format('D MMM YY') || ''})`}
        </CardContent>
      )}
    </ProjectStatusContent>
  </ProjectStatusWrapper>
);
